import { render, staticRenderFns } from "./CertExpress.vue?vue&type=template&id=b5d1c986&scoped=true&"
import script from "./CertExpress.vue?vue&type=script&lang=js&"
export * from "./CertExpress.vue?vue&type=script&lang=js&"
import style0 from "./CertExpress.vue?vue&type=style&index=0&id=b5d1c986&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d1c986",
  null
  
)

export default component.exports